import type {TMinorActionDataAcceptSlyDeal} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import Card from '~/models/game/Card'
import {propertyCardFactory} from '~/models/game/factories'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMinorActionUserFacingDescriptionData} from '~/models/game/MinorAction'
import MinorAction from '~/models/game/MinorAction'
import type {AnyPropertyCard} from '~/models/game/types'
import {mutateIf} from '~/utils/etc'
import {sentenceCase, xVerbY} from '~/utils/language'

export default class MinorActionAcceptSlyDeal extends MinorAction<TMinorActionDataAcceptSlyDeal> {
  requestedCard: AnyPropertyCard

  constructor(data: TMinorActionDataAcceptSlyDeal) {
    super(data)
    this.requestedCard = propertyCardFactory(data.requestedCard)
  }

  userFacingDescription({
    tense,
    majorActor,
    minorActor,
    skin,
    gamePosition,
  }: TMinorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined

    const dropFirstNoun = tense === 'imperativePrompt'

    const {conjugatedVerb, xNoun, yNounPossessive} = xVerbY(
      tense,
      minorActor,
      dropFirstNoun ? 'Accept' : 'accept',
      majorActor,
      currentPlayer?.id
    )

    return skins[skin].gameLogDescriptions.minorActionResponses.acceptSlyDeal({
      tense,
      actor: dropFirstNoun
        ? undefined
        : xNoun === minorActor.username
          ? xNoun
          : sentenceCase(xNoun),
      verb: mutateIf(conjugatedVerb, dropFirstNoun, sentenceCase),
      targetPossessive: yNounPossessive,
      cardName: Card.displayNameForCard('slyDeal', skin),
    })
  }
}
